export const MINAINNEHAV_ORG = "njorda-minainnehav-saas";
